function ImgContainer({ path }) {
  return (
    <div className="img-container">
      <img src={`img/${path}`} alt="India Elects banner" />
    </div>
  );
}
export default ImgContainer;